import { useMemo } from 'react';
import { useEventInfo } from './useEventInfo';
import { useIsNewStackEvent } from './useIsNewStackEvent';
import { resolveRsvpRoute } from './rsvpRoute';
import type { RsvpRoute } from './rsvpRoute.types';

/**
 * Deliberately NOT re-exported from `@shared/utils/eventInfo`, for the same reason as
 * `useIsNewStackEvent` and `useGuestListRoute`, which this hook sits alongside.
 */
export const useRsvpRoute = (): RsvpRoute => {
  const { eventInfo } = useEventInfo();
  const isNewStackEvent = useIsNewStackEvent();

  return useMemo(
    () =>
      resolveRsvpRoute({
        eventType: eventInfo?.eventType,
        isNewStackEvent,
      }),
    [eventInfo?.eventType, isNewStackEvent],
  );
};
